
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { YourPension } from '../../model/ngrx/your-pension.model';

export const ADD_YOUR_PENSION = '[YOURPENSION] Add';
export const REMOVE_YOUR_PENSION = '[YOURPENSION] Remove';

// AddPersonalDetails
export class AddYourPension implements Action {
    readonly type = ADD_YOUR_PENSION;

    constructor(public payload: YourPension) { }
}
// RemovePersonalDetails
export class RemoveYourPension implements Action {
    readonly type = REMOVE_YOUR_PENSION;

    constructor(public payload: number) { }
}

export type Actions = AddYourPension | RemoveYourPension;
